export default __webpack_public_path__ + "8dbea531de3e84432f415ba35e0cda9c.png";